import { CommitmentTypes, ICommitmentEditorItem } from '../models'

/** Caption of a card's Sign-Off button; dialogs that continue the sign-off reuse it. */
export const getSignOffButtonCaption = (
  item: Pick<ICommitmentEditorItem, 'CommitmentType' | 'EntryId' | 'Dropped'>,
  isPartnerUser: boolean
) => {
  if (item.CommitmentType === CommitmentTypes.Partner && isPartnerUser) {
    return 'partnercommitment-sign-off-on-behave'
  }

  if (item.EntryId || (item.CommitmentType === CommitmentTypes.PBM && !item.Dropped)) {
    return 'partnercommitment-resign'
  }

  return 'partnercommitment-sign-off'
}
